module.exports = __webpack_public_path__ + "media/images/dashboard-profile-progress-crown-a4ad1e52.png";